import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { filter } from 'lodash'
import { Button, Box, CircularProgress, Container, Grid, Paper, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { PageTitle } from '@scoir/headers'

import api from 'common/api'
import Card from './Card'

const getRouteUrl = (scid) => `/api/colleges/${scid}/batches/fields`

export class BatchIndexFile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: false,
      saved: false,
      loaded: false,
    }
  }
  componentDidMount() {
    document.title = 'Scoir - Batch Index File Configuration'
    this.retrieve()
  }

  retrieve() {
    api.get(getRouteUrl(this.props.scid)).then((result) =>
      this.setState({
        ...result,
        error: false,
        saved: false,
        loaded: true,
      }),
    )
  }

  toggle(field) {
    field.Selected = !field.Selected
    this.setState({
      ...this.state,
      error: false,
      saved: false,
    })
  }

  save() {
    this.setState({ error: false, saved: false })
    api
      .put(getRouteUrl(this.props.scid), this.state.Fields)
      .then(() => this.setState({ saved: true }))
      .catch(() => this.setState({ error: true }))
  }

  renderCard(field) {
    return (
      <Card
        required={field.Required}
        selected={field.Selected}
        label={field.Label}
        examples={field.Examples}
        onToggle={() => !field.Required && this.toggle(field)}
        key={field.FieldName}
        fieldName={field.FieldName}
      />
    )
  }

  render() {
    return (
      <Container maxWidth="md">
        <PageTitle title="Export - Index File Configuration" />
        <Typography paragraph>
          Configure the fields that you would like to include and save the settings for your future exports.
        </Typography>
        {!this.state.loaded && (
          <Box
            p={8}
            textAlign="center"
          >
            <CircularProgress
              role="status"
              aria-label="Loading"
              size={50}
            />
          </Box>
        )}
        {this.state.loaded && (
          <Box
            component={Paper}
            my={3}
            p={2}
          >
            <Grid
              container
              spacing={3}
            >
              {filter(this.state.Fields, { Required: true }).map((field) => this.renderCard(field))}
              {filter(this.state.Fields, { Required: false }).map((field) => this.renderCard(field))}
            </Grid>
            <Box mt={3}>
              {(this.state.error || this.state.saved) && (
                <Box my={3}>
                  {this.state.error && <Alert severity="error">Error saving field configuration.</Alert>}
                  {this.state.saved && <Alert severity="success">Saved successfully.</Alert>}
                </Box>
              )}
              <Box
                display="flex"
                gridGap={8}
              >
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => this.retrieve()}
                >
                  Discard changes
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => this.save()}
                >
                  Save changes
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Container>
    )
  }
}

BatchIndexFile.propTypes = {
  scid: PropTypes.number.isRequired,
}

export default connect((store) => ({
  scid: store.user.record.Scid,
}))(BatchIndexFile)
